import { z } from "zod";

export const ContasPagamentoSchema = z.object({
    idsContasPagar: z.coerce.number().array().default([]),
    idBancoPagamento: z.coerce.number().nullable().default(null),
    dataPagamento: z.coerce.date({ invalid_type_error: "Data de recebimento inválida." }),
    formaPagamento: z.coerce.string().optional(),
    nroDocumento: z.coerce.string().optional(),
    nroNotaFiscal: z.coerce.string().optional(),
    observacao: z.coerce.string().optional(),

});

export type ContasPagamentoForm = z.infer<typeof ContasPagamentoSchema>;

export const defaultContasPagamentoForm: Partial<ContasPagamentoForm> = {
    idsContasPagar: [],
    idBancoPagamento: null,
    dataPagamento: new Date(),
    formaPagamento: "",
    nroDocumento: "",
    nroNotaFiscal: "",
    observacao: "",

}